import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
import {
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
/** Reducers Import */
import DrawerReducer from '../Reducer/DrawerReducer';
import BreadCrumbsReducer from '../Reducer/BreadCrumbsReducer';
import BaseInfoReducer from '../Reducer/BaseInfoReducer';
import SnackbarReducer from '../Reducer/SnackbarReducer';
import ModalReducer from '../Reducer/ModalReducer';
import GridReducer from '../Reducer/GridReducer';
import StatusFlagsReducer from '../Reducer/StatusFlagsReducer';
import SearchReducer from '../Reducer/SearchReducer';
import LoadingReducer from '../Reducer/LoadingReducer';
import InAppNotiReducer from '../Reducer/InAppNotiReducer';
import FileFieldReducer from '../Reducer/FileFieldReducer';
import ErrorDialogReducer from '../Reducer/ErrorDialogReducer';
import DetailDialogReducer from '../Reducer/DetailDialogReducer';

// RootReducer(여러 reducer를 하나로 묶어주는 메소드)
const reducers = combineReducers({
  // slice reducer(세부 reducer)
  drawers: DrawerReducer,
  menus: BreadCrumbsReducer,
  BaseInfo: BaseInfoReducer,
  snackbar: SnackbarReducer,
  modal: ModalReducer,
  grid: GridReducer,
  StatusFlags: StatusFlagsReducer,
  SearchInfo: SearchReducer,
  loading: LoadingReducer,
  inAppNoti: InAppNotiReducer,
  fileField: FileFieldReducer,
  errorDialog: ErrorDialogReducer,
  detailDialog: DetailDialogReducer,
});

// persistConfig: 어떤 상태를 저장할지 설정
const persistConfig = {
  key: 'root', // 로컬스토리지에 저장할 때 사용할 key (localStorage에 root라는 이름으로 저장됨)
  storage, // 어디에 저장할 건지: localStorage를 사용함
  whitelist: ['menus', 'BaseInfo'], // 어떤 state 저장할 건지
};

// persistReducer() : 기존 reducer에 "저장 기능"을 추가해주는 함수(새로고침 후에도 localStorage에서 다시 불러옴)
const persistedReducer = persistReducer(persistConfig, reducers);

// configureStore: store 생성
export default configureStore({
  reducer: persistedReducer, // persistedReducer를 사용해서 저장 기능이 추가된 상태 관리
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // getDefaultMiddleware : 	Redux 기본 미들웨어 사용
      serializableCheck: {
        // serializableCheck : 데이터가 안전한 형식인지 검사 (기본으로 켜져 있음)
        ignoredActions: [
          // ignoredActions : 이 리스트에 있는 액션은 검사하지 않음
          FLUSH,
          REHYDRATE,
          PAUSE,
          PERSIST,
          PURGE,
          REGISTER,
        ],
      },
    }),
});
